<template>

  <modalo
    :title="integration.label || integration.integration"
    type="mini"
    @hideModal="close()">

    <p
      v-if="integration.description"
      class="subtext">{{ integration.description }}</p>

    <form @submit.prevent="connect()">
      <IntegrationFields
        v-model="form"
        autofocus
        :fields="fields"
        :errors="validateErrors"
        :disabled="loading" />
    </form>

    <div
      v-if="errorMessage"
      class="alert alert-warning">
      {{ errorMessage }}
    </div>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="button"
          class="btn btn-light mr-2"
          :disabled="loading"
          @click="close()">{{ $t('Cancel') }}</button>
        <button
          type="button"
          class="btn btn-primary"
          :disabled="loading"
          @click="connect()">{{ $t('Connect') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
import IntegrationFields from '../IntegrationFields'

export default {
  name: 'FormConnect',
  components: {
    IntegrationFields
  },
  props: {
    integration: {
      type: Object,
      required: true
    }
  },
  data () {
    // o formSchema pode vir como array ou como função que devolve o array
    const schema = this.integration.auth.formSchema
    const fields = typeof schema === 'function' ? schema() : (schema || [])
    const form = {}

    fields.forEach((field) => {
      form[field.key] = field.default === undefined ? null : field.default
    })

    return {
      loading: false,
      validateErrors: {},
      errorMessage: null,
      fields: fields,
      form: form
    }
  },
  methods: {
    /*
    connect
    cria a conexão com os dados do auth.formSchema
    */
    connect () {
      this.loading = true
      this.validateErrors = {}
      this.errorMessage = null

      this.$store
      .dispatch('createConnection', {
        integration: this.integration.integration,
        data: Object.assign({}, this.form)
      })
      .then((result) => {
        this.$emit('connected', result)
      })
      .catch((err) => {
        const data = err.response && err.response.data
        if (data && data.name === 'ValidationError') {
          this.validateErrors = data.errors
        } else {
          this.errorMessage = (data && data.message) || this.$t('Something went wrong')
        }
      })
      .finally(() => {
        this.loading = false
      })
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integrations/connectors/form/Connect.vue